import React from 'react';
import { graphql, useFragment } from 'react-relay';
import type { versionMenuItem_softwareBacklog$key } from '@atlassian/jira-relay/src/__generated__/versionMenuItem_softwareBacklog.graphql';
import {
	MenuNodeType,
	type MenuItemNodeArgs,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';
import { ContextMenuItem } from '@atlassian/jira-software-context-menu/src/ui/menu-renderer/context-menu-inner/context-menu-node/context-menu-item/index.tsx';
import { useAddIssuesToVersionMutation } from '../../../../../../../../common/hooks/use-add-issues-to-version-mutation';
import type { CardId } from '../../../../../../../../model/types';
import { VERSION_MENU_ID } from '../../../../constants';

export type Props = {
	selectedCardIds: CardId[];
	menuItemNodeArgs: MenuItemNodeArgs;
	versionEdge: versionMenuItem_softwareBacklog$key;
};

export const VersionMenuItem = ({ selectedCardIds, versionEdge, menuItemNodeArgs }: Props) => {
	const {
		node: { id: versionAri, versionId, name },
	} = useFragment(
		graphql`
			fragment versionMenuItem_softwareBacklog on JiraVersionEdge {
				node @required(action: THROW) {
					id @required(action: THROW)
					versionId @required(action: THROW)
					name @required(action: THROW)
				}
			}
		`,
		versionEdge,
	);

	const addIssuesToVersionMutation = useAddIssuesToVersionMutation();

	return (
		<ContextMenuItem
			{...menuItemNodeArgs}
			menuItem={{
				type: MenuNodeType.Item,
				id: `${VERSION_MENU_ID}/menu/value__${versionId}`,
				label: name,
				onClick: (analyticsEvent) => {
					addIssuesToVersionMutation(selectedCardIds, versionAri, analyticsEvent);
				},
			}}
		/>
	);
};
